export type BroadcastParamCondition = {
  key: string;
  values: string[];
  include: boolean;
};
export type BroadcastStatusCondition = { values: string[] };

export enum BroadcastType {
  draft = 'DRAFT',
  flow = 'FLOW',
}

export enum BroadcastStatus {
  draft = 'DRAFT',
  planned = 'PLANNED',
  creating = 'CREATING',
  started = 'STARTED',
}

export interface IBroadcast {
  _id: string;
  name: string;
  type: BroadcastType;
  flow?: string;
  telegramBot: string;
  recipientsCount: number;
  startTime: Date | null;
  endTime: Date | null;
  status: BroadcastStatus;
  paramConditions: BroadcastParamCondition[];
  statusConditions: BroadcastStatusCondition;
  owner: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface CreateBroadcast
  extends Omit<
    IBroadcast,
    | '_id'
    | 'createdAt'
    | 'updatedAt'
    | 'endTime'
    | 'startTime'
    | 'status'
    | 'owner'
    | 'telegramBot'
    | 'recipientsCount'
  > {
  startTime: string;
}

export interface UpdateBroadcast
  extends Omit<
    IBroadcast,
    | '_id'
    | 'createdAt'
    | 'updatedAt'
    | 'endTime'
    | 'startTime'
    | 'status'
    | 'owner'
    | 'telegramBot'
    | 'recipientsCount'
  > {
  startTime: string;
}
